import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=271d9a74&scoped=true&"
import script from "./checkout.vue?vue&type=script&lang=ts&"
export * from "./checkout.vue?vue&type=script&lang=ts&"
import style0 from "./checkout.vue?vue&type=style&index=0&id=271d9a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d9a74",
  null
  
)

export default component.exports